import { Card } from '@/components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const QA = [
  { q: 'Comment puis-je faire confiance à un jobeur ?', a: 'Chaque jobeur passe par 3 niveaux de vérification (téléphone, identité, historique). Les avis sont vérifiés : seuls les clients ayant réalisé un job peuvent noter.' },
  { q: 'Pourquoi je ne peux pas payer en dehors de Job Kongo ?', a: "Pour votre sécurité et celle du jobeur. Le paiement en séquestre garantit que les fonds ne sont libérés qu'après votre validation. Payer en dehors entraîne l'exclusion définitive." },
  { q: 'Que se passe-t-il si je ne valide pas ?', a: 'Si aucune réclamation dans les 48h après la fin du service, les fonds sont automatiquement libérés au jobeur.' },
  { q: 'Combien coûte la plateforme ?', a: "La plateforme prélève 10% sur la main d'œuvre (répartie entre assurance, fonctionnement, salaires, marketing et œuvres sociales) et 3% d'assurance sur les frais annexes." },
  { q: 'Quels moyens de paiement sont acceptés ?', a: 'Mobile Money (Airtel, Orange, M-Pesa, Africell), virement bancaire (Rawbank, Equity BCDC, etc.), Visa pour la diaspora, et Pi Network.' },
  { q: 'Comment contester un travail mal fait ?', a: "Avant de valider, vous pouvez ouvrir un litige. L'équipe Job Kongo médie et peut débloquer un remboursement partiel ou total via le fonds d'assurance." },
  { q: 'Comment devenir “Jobeur de confiance” ?', a: "Réalisez au moins 5 jobs avec une note moyenne supérieure ou égale à 4/5. Le badge or est attribué automatiquement." },
  { q: 'Y a-t-il des taxes à payer ?', a: "Si vos revenus dépassent 3000$/an sur la plateforme, les taxes congolaises (TVA etc.) s'appliquent. Un relevé fiscal est généré automatiquement." },
];

export default function FAQPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-6 py-10">
      <h1 className="text-3xl md:text-4xl font-bold text-center">Questions fréquentes</h1>
      <p className="text-center text-slate-600 mt-2">Tout ce que vous devez savoir sur Job Kongo.</p>
      <Card className="mt-6 p-4">
        <Accordion type="single" collapsible>
          {QA.map((it, i) => (
            <AccordionItem key={i} value={`q${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-semibold">{it.q}</AccordionTrigger>
              <AccordionContent className="text-slate-700">{it.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Card>
    </div>
  );
}
